import { Alert, Link, Typography } from '@mui/material';
import { useState } from 'react';

export default function FederalEVIncentiveAlert({ href }: { href: string }) {
  const [showIncentiveAlert, setShowIncentiveAlert] = useState(
    !globalThis.localStorage.getItem('closedIncentiveAlert'),
  );
  const handleClosedIncentiveAlert = () => {
    globalThis.localStorage.setItem('closedIncentiveAlert', 'true');
    setShowIncentiveAlert(false);
  };

  if (!showIncentiveAlert) {
    return null;
  }

  return (
    <Alert
      onClose={handleClosedIncentiveAlert}
      severity="info"
      variant="filled"
      sx={{
        width: '100%',
        borderRadius: 0,
        '.MuiAlert-icon': {
          alignItems: 'center',
          color: 'common.black',
        },
        '.MuiAlert-action': {
          alignItems: 'center',
          color: 'common.black',
        },
      }}
    >
      <Typography component={'p'} color="common.black">
        If you purchased an EV prior to September 30, 2025, you may still be eligible for the
        Federal EV Tax Credit program.
      </Typography>
      <Typography component={'p'} sx={{ mt: 1 }} color="common.black">
        Many popular EV makes and models were eligible for the federal incentive. Visit{' '}
        <Link color="common.black" sx={{ fontWeight: 'bold' }} href={href}>
          this link
        </Link>{' '}
        to learn more.
      </Typography>
    </Alert>
  );
}
